var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewInboxIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.60807 18.2594H16.3919C17.3256 18.2594 18 17.6369 18 16.9107V4.72046C18 3.94236 17.2738 3.37176 16.3919 3.37176H13.072V4.51297H16.3919C16.5476 4.51297 16.6513 4.61671 16.6513 4.72046V16.8588C16.6513 16.9625 16.5476 17.0663 16.3919 17.0663H1.60807C1.45245 17.0663 1.3487 16.9625 1.3487 16.8588V4.72046C1.3487 4.61671 1.45245 4.51297 1.60807 4.51297H4.72046V3.37176H1.60807C0.674352 3.37176 0 3.99424 0 4.72046V16.8588C0 17.6369 0.726225 18.2594 1.60807 18.2594Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.7839 14.0576H10.4265V14.4726H14.7839V14.0576Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.7839 15.562H10.4265V15.9769H14.7839V15.562Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6715 14.8357H10.4265V15.2507H11.6715V14.8357Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.5389 14.8357H12.2939V15.2507H13.5389V14.8357Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.82423 6.22478L8.5591 9.2853C8.81846 9.4928 9.18157 9.4928 9.44094 9.2853L13.1758 6.22478C13.5908 5.91355 13.2796 5.34294 12.709 5.34294H11.3084V0H6.63979V5.34294H5.18734C4.66861 5.34294 4.40924 5.91355 4.82423 6.22478Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewInboxIcon);
export default __webpack_public_path__ + "static/media/NewInboxIcon.5bbf05e386469f8eb4d7ef82a35ae285.svg";
export { ForwardRef as ReactComponent };